// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__NQRBk","label":"Section_label__Q6Zkn","contentWrap":"Section_contentWrap__23WUq","footer":"Section_footer__1wxwF","footerInner":"Section_footerInner__yY0f5"};